import PropertyDataCarousel from './PropertyDataCarousel';

export default PropertyDataCarousel;
